import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ExternalLink } from 'lucide-react';
import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="border-b bg-white shadow-sm z-10">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/" className="text-xl font-bold flex items-center">
            <img 
              src="/logo.png" 
              alt="Cyber Web Solution" 
              className="h-8 w-auto mr-2"
            />
            PDF Editor
          </Link>
          <nav className="hidden md:flex items-center space-x-2">
            <Button asChild variant="ghost" className="gap-2">
              <a href="https://cybercws.in" target="_blank" rel="noopener noreferrer">
                Home <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </Button>
            <Button asChild variant="ghost" className="gap-2">
              <a href="https://cybercws.in/#contact" target="_blank" rel="noopener noreferrer">
                Contact <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </Button>
            <Button asChild variant="ghost">
              <Link to="/stamper">PDF Stamper</Link>
            </Button>
            <Button asChild variant="ghost">
              <Link to="/pdf-converter">PDF Converter</Link>
            </Button>
          </nav>
        </div>
      </header>
      
      <main className="flex-1 container mx-auto p-4">{children}</main>
      
      <footer className="bg-gray-50 border-t py-6 mt-auto">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-600 mb-4 md:mb-0">
              © {new Date().getFullYear()} <a href="https://cybercws.in" className="hover:underline" target="_blank" rel="noopener noreferrer">Cyber Web Solution</a>. All Rights Reserved.
            </div>
            <div className="flex space-x-4">
              <a 
                href="https://cybercws.in/privacy-policy" 
                className="text-sm text-gray-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <span className="text-gray-400">|</span>
              <a 
                href="https://cybercws.in/terms-of-service" 
                className="text-sm text-gray-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
